import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, TrendingUp } from 'lucide-react';

export default function ProposalDevelopmentPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <FileText size={56} style={{ color: 'var(--gold-primary)', marginBottom: '24px' }} />
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Proposal Development</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              End-to-end proposal writing and development services that transform your technical capabilities into compelling, compliant, and competitive submissions.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-light">
        <div className="section-content">
          <h2 style={{ marginBottom: '32px', textAlign: 'center' }}>What We Deliver</h2>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <p style={{ fontSize: '18px', color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '24px' }}>
              Our proposal development services cover the full writing and content creation process, from executive summaries through technical volumes and past performance narratives. We work as an extension of your team, transforming subject matter expert input into polished, evaluator-friendly content.
            </p>
            <ul style={{ fontSize: '18px', color: 'var(--text-secondary)', lineHeight: '2', marginLeft: '24px' }}>
              <li>Executive summary and cover letter development</li>
              <li>Technical approach narrative writing</li>
              <li>Management approach and staffing sections</li>
              <li>Past performance descriptions and relevance mapping</li>
              <li>Pricing narrative and cost volume support</li>
              <li>Compliance matrix cross-referencing</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Ready to Develop a Winning Proposal?</h2>
            <Link to="/contact" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
